import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
// eslint-disable-next-line import/extensions
import languages from '../constants/i18n.json';

const detectionOptions = {
  order: ['querystring', 'localStorage'],
  lookupFromPathIndex: 0,
  lookupQuerystring: 'lang',
  lookupLocalStorage: 'i18nextLng',
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(
    {
      fallbackLng: 'de',
      detection: detectionOptions,
      keySeparator: '.',

      resources: languages,
      interpolation: {
        escapeValue: false, // react already safes from xss
      },
      debug: false,
    },
    () => {
      // if (err) console.error(err);
    },
  );

export default i18n;
